module.exports = __webpack_public_path__ + "img/header.b0723a30.png";